import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SportsNavBar from "../../components/common/SportsNavBar";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { fetchMLBNews } from "../../services/api";

function MLB() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    const data = await fetchMLBNews();
    setArticles(data);
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>MLB News | Bharat Abroad Sports</title>
        <meta
          name="description"
          content="Latest MLB scores, rankings, player stats, and match analysis."
        />
      </Helmet>

      <SportsNavBar />

      <div
        style={{ background: "#f5f5f5", minHeight: "100vh", padding: "20px" }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <NewsSection title="MLB News" articles={articles} category="mlb" />
        </div>
      </div>
    </>
  );
}

export default MLB;
